import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Bell, BellRing, Check, UserPlus, ShieldCheck, CreditCard, Package } from 'lucide-react';
import { EmptyState } from './shared';
import api from '@/lib/api';
import { toast } from 'sonner';

export function NotificationsTab({ notifications, notifUnread, setNotifications, setNotifUnread }) {
  const markAllRead = async () => {
    await api.put('/admin/notifications/read');
    setNotifUnread(0);
    setNotifications(prev => prev.map(n => ({ ...n, read: true })));
    toast.success('Toutes les notifications marquees comme lues');
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold flex items-center gap-2">
          <BellRing className="w-5 h-5 text-[#F25C05]" />
          Notifications ({notifications.length})
          {notifUnread > 0 && <Badge className="bg-red-500 text-white">{notifUnread} non lue(s)</Badge>}
        </h3>
        {notifUnread > 0 && (
          <Button size="sm" variant="outline" onClick={markAllRead} data-testid="mark-all-read-btn">
            <Check className="w-4 h-4 mr-1" /> Tout marquer comme lu
          </Button>
        )}
      </div>
      {notifications.length === 0 ? <EmptyState icon={Bell} text="Aucune notification" /> : (
        <div className="space-y-2">
          {notifications.map(notif => (
            <div key={notif.id} className={`p-4 rounded-lg border transition-colors ${notif.read ? 'bg-white dark:bg-neutral-800 border-neutral-200 dark:border-neutral-700' : 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800'}`} data-testid={`notification-${notif.id}`}>
              <div className="flex items-start gap-3">
                <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${
                  notif.type === 'new_registration' ? 'bg-emerald-100 dark:bg-emerald-900/30' :
                  notif.type === 'verification_request' ? 'bg-amber-100 dark:bg-amber-900/30' :
                  notif.type === 'payment' ? 'bg-blue-100 dark:bg-blue-900/30' :
                  notif.type === 'new_listing' ? 'bg-orange-100 dark:bg-orange-900/30' :
                  'bg-neutral-100 dark:bg-neutral-700'
                }`}>
                  {notif.type === 'new_registration' && <UserPlus className="w-4 h-4 text-emerald-600" />}
                  {notif.type === 'verification_request' && <ShieldCheck className="w-4 h-4 text-amber-600" />}
                  {notif.type === 'payment' && <CreditCard className="w-4 h-4 text-blue-600" />}
                  {notif.type === 'new_listing' && <Package className="w-4 h-4 text-[#F25C05]" />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-sm">{notif.title}</span>
                    {!notif.read && <span className="w-2 h-2 rounded-full bg-blue-500 shrink-0" />}
                  </div>
                  <p className="text-sm text-neutral-600 dark:text-neutral-400 mt-0.5">{notif.message}</p>
                  <p className="text-xs text-neutral-400 mt-1">{new Date(notif.created_at).toLocaleString('fr-BE')}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
